import { IClassname } from '@/lib/shared/model/classname';

export const CeilingFan = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7754)">
        <path
          d="M13.4441 13.5077V6.73471C13.4441 3.9233 15.7443 1.62305 18.5558 1.62305H20.7282C23.0285 1.62305 24.9453 3.53992 24.9453 5.84017C24.9453 7.24588 24.1786 8.65159 23.0285 9.41834"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5559 18.4922V25.2651C18.5559 28.0766 16.2557 30.3768 13.4443 30.3768H11.2718C8.97159 30.3768 7.05469 28.4599 7.05469 26.1597C7.05469 24.754 7.82144 23.3483 8.97156 22.5815"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5082 18.5559H6.7352C3.92379 18.5559 1.62354 16.2557 1.62354 13.4443V11.2718C1.62354 8.97156 3.54044 7.05469 5.84069 7.05469C7.24639 7.05469 8.65209 7.82144 9.41884 8.97156"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4919 13.4443H25.2649C28.0763 13.4443 30.3766 15.7446 30.3766 18.556V20.7285C30.3766 23.0287 28.4597 24.9456 26.1594 24.9456C24.7537 24.9456 23.348 24.1788 22.5813 23.0287"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0001 19.5139C17.941 19.5139 19.5144 17.9405 19.5144 15.9996C19.5144 14.0587 17.941 12.4854 16.0001 12.4854C14.0592 12.4854 12.4858 14.0587 12.4858 15.9996C12.4858 17.9405 14.0592 19.5139 16.0001 19.5139Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7754">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
